import { useSearchBox } from 'react-instantsearch';

/**
 * Virtual Search Box is required for algolia to keep track of the query param `q`
 */
export const VirtualSearchBox = () => {
  useSearchBox();

  return <></>;
};
